import React, { Component } from 'react';
import PropTypes from '../../../types';
import IndustryType from './IndustryType';
import IndustryDescription from './IndustryDescription';
import IndustryData from './IndustryData';

const FINANACE_TYPE = 'Finance and Insurance';
const REAL_ESTATE = 'Real Estate, Renting and Housing Associations';

class IndustryComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      industryDescriptionData: [],
      industryDesc: props.formFieldValues.industryDescription
    };
    this.onClickIndustryType = this.onClickIndustryType.bind(this);
  }
  componentWillMount() {
    if (this.props.formFieldValues.industryType) {
      this.setState({
        industryDescriptionData: IndustryData.find(
          (industryData) => industryData.id === this.props.formFieldValues.industryType
        )
      });
    }
  }
  onClickIndustryType(value) {
    if (value) {
      if (value === FINANACE_TYPE && !this.props.isSoleBusinessType) {
        const newData = [...IndustryData].find((item) => item.id === value);
        newData.children = { ...newData }.children.filter((child) => !child.businessType);
        this.setState({
          industryDescriptionData: newData
        });
      }
      if (value === REAL_ESTATE && this.props.isSoleBusinessType) {
        const newData = [...IndustryData].find((item) => item.id === value);
        newData.children = { ...newData }.children.filter((child) => !child.businessType);
        this.setState({
          industryDescriptionData: newData
        });
      } else {
        this.setState({
          industryDescriptionData: IndustryData.find((industryData) => industryData.id === value)
        });
      }
    }
  }
  render() {
    const { formFieldValues, isSubmitted, onChange } = this.props;
    const { industryDescriptionData, industryDesc, isIndustryChanged } = this.state;
    let industryDescriptionItems = industryDescriptionData;
    if (formFieldValues.industryType && industryDescriptionItems.length < 1) {
      industryDescriptionItems = IndustryData.find(
        (industryData) => industryData.id === formFieldValues.industryType
      );
    }

    return (
      <div>
        <IndustryType
          isSubmitted={isSubmitted}
          options={IndustryData}
          onClickIndustryType={(name, value) => {
            this.onClickIndustryType(value);
            onChange(name, value);
            this.setState({ industryDesc: null, isIndustryChanged:true });
          }}
          values={formFieldValues}
        />
        {formFieldValues.industryType && (
          <IndustryDescription
            values={isIndustryChanged ? null : formFieldValues.industryDescription || industryDesc}
            isSubmitted={isSubmitted}
            options={(industryDescriptionItems && industryDescriptionItems.children) || []}
            onChange={(name, value) => {
              onChange(name, value);
              this.setState({ industryDesc: value, isIndustryChanged:false  });
            }}
          />
        )}
      </div>
    );
  }
}

IndustryComponent.propTypes = {
  formFieldValues: PropTypes.shape({
    industryType: PropTypes.string
  })
};

IndustryComponent.defaultProps = {
  formFieldValues: {
    industryType: ''
  }
};

export default IndustryComponent;
